/**
 * dev  : yangliu_11
 * desc : CMS通用视频组件 中介组件
 */
<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <div :style="{'background-color': backgroundColor}">
      <component :is="compName" :compProps="video" :compId="(compProps.elementId+'')" @action="actionHandle" :elementId="compProps.elementId" :elementName="compProps.elementName"></component>
      <component :is="servCompName" :payLoad="payLoad" :compIndex="compIndex" :compProps="compProps" @finish="finishHandle"></component>
    </div>
  </section>
</template>

<script>
import Video from '@/components/Video'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'

export default {
  mixins: [mixin],
  name: '',
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    window._fas && window._fas.setCustomTrack({
      eventname: 'C_HOME_CMS_TRAVELAROUND_ELEMNT_EXPOSURE',
      ext: {
        elementId: this.compProps.elementId,
        elementName: this.compProps.elementName,
        elementType: 1,
        url: 'https://pic.tujia.com' + this.compProps.mate.video,
        rank_list_id: this.$root.promotionId,
        rank_list_name: this.$root.htmlTitle
      }
    })
  },
  data() {
    return {
      payLoad: null
    }
  },
  computed: {
    compName() {
      return 'Video'
    },
    // 视频组件初始数据
    video() {
      if (this.compProps.mate) {
        return this.compProps.mate
      } else {
        return null
      }
    },
    backgroundColor() {
      return this.compProps.mate && this.compProps.mate.backgroundColor
    }
  },
  methods: {
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payload) {
      if (!this.$root.isPreview) {
        this.payLoad = payload
      }
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle() {
      this.payLoad = null
    }
  },
  components: {
    Video,
    ...serviceComps
  }
}
</script>

<style lang="scss" scoped>
</style>
